"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledText = styled_components_1.default.div `
  align-items: center;
  display: flex;
  font: ${({ bold }) => (bold ? 'bold' : '')}
    ${({ bold }) => (bold ? config_1.fontSizes.base : config_1.fontSizes.small)}
    ${config_1.fontFamilies.primary};
`;
